import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";
import Toast from "./Toast";
import type { ToastProps } from "./Toast";

type ToastContextType = {
  showToast: (props: Omit<ToastProps, "visible" | "onClose">) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx.showToast;
};

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toastProps, setToastProps] = useState<Omit<ToastProps, "visible" | "onClose"> | null>(null);
  const [visible, setVisible] = useState(false);

  const showToast = (props: Omit<ToastProps, "visible" | "onClose">) => {
    setToastProps(props);
    setVisible(true);
  };

  const handleClose = () => setVisible(false);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        {...(toastProps || {})}
        visible={visible}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  );
};